import { createContext } from "react";
import type { CallerContext } from "../api/generated/contracts";

export type AuthStatus = "initializing" | "unauthenticated" | "authenticated";

export interface AuthContextValue {
  readonly status: AuthStatus;
  /** The resolved caller (BRD's four roles) once GET /api/users/me has completed. */
  readonly caller: CallerContext | null;
  readonly login: () => void;
  readonly logout: () => void;
  /** True when the caller holds one of the given roles (PortfolioRoles constants). */
  readonly hasRole: (...roles: readonly string[]) => boolean;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
